var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 8.74984H2.33341C2.024 8.74984 1.72725 8.62692 1.50846 8.40813C1.28966 8.18934 1.16675 7.89259 1.16675 7.58317V2.33317C1.16675 2.02375 1.28966 1.72701 1.50846 1.50821C1.72725 1.28942 2.024 1.1665 2.33341 1.1665H7.58341C7.89283 1.1665 8.18958 1.28942 8.40837 1.50821C8.62716 1.72701 8.75008 2.02375 8.75008 2.33317V2.9165M6.41675 5.24984H11.6667C12.3111 5.24984 12.8334 5.77217 12.8334 6.4165V11.6665C12.8334 12.3108 12.3111 12.8332 11.6667 12.8332H6.41675C5.77242 12.8332 5.25008 12.3108 5.25008 11.6665V6.4165C5.25008 5.77217 5.77242 5.24984 6.41675 5.24984Z",
    stroke: "#2F2F2F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b3a24d0ff60d7e4b1efe896e8eaba8a3.svg";
export { ForwardRef as ReactComponent };